import { getCsrfToken } from "./csrf";

export function localLogout() {
    localStorage.removeItem('user');
    window.location.reload();
}

export async function logout() {
    try {
        await fetch("/api/auth/logout", {
            method: "POST",
            headers: { 'X-Csrftoken': getCsrfToken() }
        });
    } catch {
        return
    }
    localLogout();
}